import { render, staticRenderFns } from "./ForceToAddBankAndWallet.vue?vue&type=template&id=4884339d"
import script from "./ForceToAddBankAndWallet.vue?vue&type=script&lang=js"
export * from "./ForceToAddBankAndWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports